import { Component, h, Prop, Element, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'signet-header',
  styleUrl: 'signet-header.scss',
})
export class SignetHeader implements ComponentInterface {
  $headerContent: HTMLElement;
  headerId = `header_${headerIds++}`;

  @Element() $el: HTMLElement;

  @Prop() logo:
    | 'episource'
    | 'coder'
    | 'analyst'
    | 'submitter'
    | 'hub'
    | 'signet'
    | 'connect'
    | 'adaptive-coder'
    | 'portal' = 'signet';
  @Prop() fixed: 'top' | 'bottom';

  // Forwardable props for signet-logo
  @Prop() logoSrc?: string;
  @Prop() logoAlt?: string;
  @Prop() logoHref?: string;

  render() {
    const classes = {
      'signet-header-container': true,
      [`fixed-${this.fixed}`]: !!this.fixed,
    };
    return (
      <div class={classes}>
        <div class="header-branding">
          <slot name="logo">
            <signet-logo
              name={this.logo}
              src={this.logoSrc}
              alt={this.logoAlt}
              href={this.logoHref}
              class="logo"
            />
          </slot>
        </div>
        <div
          class="header-content"
          id={`header-content-${this.headerId}`}
          ref={(el) => (this.$headerContent = el)}
        >
          <slot />
        </div>
      </div>
    );
  }
}

let headerIds = 0;
